import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminPortal from './admin/AdminPortal';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<AdminPortal />} />
      </Routes>
    </BrowserRouter>
  );
}
